(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name thismomentGlowModuleCarousel
     * @module thismoment.glow.component.module.carousel
     *
     * @description
     * Embeds a configurable carousel into a Glow page.
     */

  const MODULE_NAME = 'thismoment.glow.component.module.carousel'
  const templateUrl = require('./tpl/module-carousel.html')
  const Swiper = require('swiper').default
  const Modernizr = require('modernizr')

  require('./scss/carousel.scss')
  require('../../../../common/scss/loader.scss')

  angular
    .module(MODULE_NAME, [
      require('../../../../common/component/loader')
    ])
    .component('thismomentGlowModuleCarousel', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        gridId: '<',
        name: '<',
        cardOptions: '<',
        cardSharing: '<',
        loaderColor: '<',
        layoutOptions: '<',
        playlistId: '<',
        busy: '=',
        items: '='
      },
      controller: glowCarouselController
    })

  glowCarouselController.$inject = ['$document', '$timeout', '$rootScope', '$scope', 'SdkConfig']
  function glowCarouselController ($document, $timeout, $rootScope, $scope, SdkConfig) {
    const vm = this

    vm.$onInit = carouselInit
    function carouselInit () {
      vm.styles = {
        container: {
          'background-color': vm.layoutOptions.background_color
        },
        leftArrow: {},
        rightArrow: {}
      }
      vm.cardOptions = vm.cardOptions || {}
      vm.cardOptions.dateTop = vm.layoutOptions.date_top
      vm.cardOptions.cardHeight = vm.layoutOptions.card_height
      vm.cardOptions.topDateBgColor = vm.layoutOptions.date_color
      vm.cardOptions.cardBG = '#fff'
      vm.cardOptions.layout = 'carousel'
      vm.cardOptions.overlay_click = vm.layoutOptions.overlay_click
      vm.cardOptions.maxWidth = getCardWidth()
      vm.carouselCardsRendered = carouselCardsRendered
      applyStyles()

      $scope.$on('breakpoint:resize', function () {
        applyStyles()
        $scope.$apply()
      })
    }

    /*
     * The callback function to init Swiper
     */
    function carouselCardsRendered () {
      // wrapped in a timeout to avoid $digest conflicts
      $timeout(function () {
        const sliderConfig = {
          direction: 'horizontal',
          loop: false,
          speed: 600,
          slidesPerView: vm.layoutOptions.card_count,
          slidesPerGroup: vm.layoutOptions.card_count,
          spaceBetween: vm.layoutOptions.space_between,
          navigation: {
            nextEl: '.swiper-button-next-' + vm.gridId,
            prevEl: '.swiper-button-prev-' + vm.gridId
          },
          breakpoints: {
            480: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 15
            },
            767: {
              slidesPerView: vm.layoutOptions.card_count === 1 ? 1 : 2,
              slidesPerGroup: vm.layoutOptions.card_count === 1 ? 1 : 2,
              spaceBetween: 15
            }
          },
          on: {
            init: function () {
              $scope.$broadcast('carousel:activated')
              $scope.$apply()
            }
          }
        }

        // init Swiper
        // eslint-disable-next-line no-unused-vars
        var slider = new Swiper('.swiper-' + vm.gridId, sliderConfig)
        vm.busy = false
        vm.showCarousel = true

        // shim for IE11
        if (!Modernizr.objectfit) {
          angular.forEach($document[0].querySelectorAll('#carousel-' + vm.playlistId + ' thismoment-card'), (card) => {
            const imgElem = card.querySelector('img')
            const imgUrl = imgElem.src
            if (imgUrl) {
              imgElem.parentElement.style.backgroundImage = 'url(' + imgUrl + ')'
              imgElem.parentElement.classList.add('compat-object-fit')
            }
          })
        }
      })
    }

    function getCardWidth () {
      var $wrapperWidth = document.getElementById('glow-page').offsetWidth
      var cardCount = vm.layoutOptions.card_count
      if (cardCount > 1) {
        cardCount = window.innerWidth <= 480 ? 1 : window.innerWidth <= 767 ? 2 : cardCount
      }
      return cardCount === 1 ? null : (($wrapperWidth - 100) - (vm.layoutOptions.space_between * (cardCount - 1))) / cardCount
    }

    function applyStyles () {
      if (SdkConfig.get('breakpoint') === 'xs') {
        vm.styles.container.height = (parseInt(vm.layoutOptions.card_height, 10) + 125).toString() + 'px'
        vm.styles.leftArrow = {
          'background-size': '20px',
          bottom: '20px',
          'margin-top': 0,
          top: 'auto',
          width: '25px'
        }
        vm.styles.rightArrow = {
          'background-size': '20px',
          bottom: '20px',
          'margin-top': 0,
          top: 'auto',
          width: '25px'
        }
        vm.styles.leftArrow.left = 'calc(40% - 30px)'
        vm.styles.rightArrow.right = 'calc(40% - 30px)'
      } else {
        vm.styles.container.height = (parseInt(vm.layoutOptions.card_height, 10) + 100).toString() + 'px'
        vm.styles.leftArrow = vm.styles.rightArrow = {}
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-carousel/index.js